// Library
import React from 'react'

// Assets
import WhiteLogo from 'assets/images/white-logo.png'
import GlobeLogo from 'assets/images/paytrack-logo.png'
import PaymentLogo from 'assets/images/proof-of-payment.png'

// Ui
import Row from 'ui/Row'
import Col from 'ui/Col'
import Heading from 'ui/Heading'
import Text from 'ui/Text'

export default function ResetPasswordWhitelist() {
  return (
    <Row className="m-0 vh-100" style={{ backgroundColor: '#1351aa' }}>
      <Col
        xs={{ span: 10, offset: 1, vcenter: true }}
        sm={{ span: 11, offset: 1, vcenter: true }}
        md={{ span: 10, offset: 2, vcenter: true }}
        lg={{ span: 6, offset: 2, vcenter: true }}
      >
        <Row>
          <Col xs={12}>
            <img className="d-block mw-100" src={WhiteLogo} alt="globeLogo" width={"128"} />
            <img className="mw-100" src={GlobeLogo} alt="paytrackLogo" />
          </Col>
          <Col xs={12}>
            <Heading
              size={26}
              color="#ffffff"
              paddingTop={45}
              paddingBottom={10}
            >
              Hi there! Paytrack has migrated its User Management System and Social Login is decomissioned. In this case, you are required to reset your password.
            </Heading>
            <Text color="#ffffff" paddingBottom={45}>
              Please check your email. <br />
              We sent you a message with the link to reset your password in
              Paytrack
            </Text>
          </Col>
          <Col xs={8} sm={4}>
            <img className="mw-100" src={PaymentLogo} alt="paymentLogo" />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
